export default __webpack_public_path__ + "static/media/regis.5988094e.png";